import apiClient from "./apiClient";
import { cleanObject } from "../utils/commonutils";

const Url = `/inquiry`;

export const getInquiryList = async (
  props,
  currentPage,
  rowsPerPage,
  searchText,
  followUpBefore,
  type
) => {
  try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (searchText && searchText.trim() !== "") {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }
    if(followUpBefore ){
      url += `&nextFollowupDate=${followUpBefore}`
    }
    if (type && type !== "all") {
      url += `&type=${encodeURIComponent(type)}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const getInquiryDetail = async (payload, props) => {
  try {
    if (!payload) return false;

    let response = await apiClient.get(`${Url}/${payload}`);

    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const addInquiry = async (props, Data) => {
  try {
    let body = {
      name: Data?.name,
      mobile: Data?.phone,
      email: Data?.email,
      service: Data?.service,
      source: Data?.source,
      priority: Data?.priority,
      assignedTo: Data?.assignedTo?._id || Data?.assignedTo,
      notes : Data?.note || "",
      status :Data?.status,
      type: Data?.type || "general",
    };

    const cleanBody = cleanObject(body);
    let response = await apiClient.post(Url, cleanBody);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const convertInquiry = async (props, inquiryId, body) => {
  try {
    const response = await apiClient.post(`${Url}/${inquiryId}/convert`, body);
    return response.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const editInquiry = async (props, Data, editId) => {
  try {
    let body = {
      name: Data?.name,
      mobile: Data?.phone,
      email: Data?.email,
      service: Data?.service,
      source: Data?.source,
      priority: Data?.priority,
      ...(Data?.assignedTo && {
        assignedTo: Data?.assignedTo?._id || Data?.assignedTo,
      }),
      notes : Data?.note || "",
      status :Data?.status,
      type: Data?.type || "general",
    };

    let response = await apiClient.put(`${Url}?inquiryId=${editId}`, body);
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const deleteInquiry = async (inquiryId, props) => {
  try {
    if (!inquiryId) return false;

    let response = await apiClient.delete(`${Url}?inquiryId=${inquiryId}`);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const Addfollowup = async (props, Data) => {
  try {
    let body = {
      inquiryId: Data?.inquiryId,
      type: Data?.type,
      outcome:Data?.outcome,
      notes: Data?.notes,
      nextFollowupDate: Data?.nextFollowupDate,
      createdBy:props?.authData?.ClidToken,
    };

    const cleanBody = cleanObject(body);

    let response = await apiClient.post(`${Url}-followup`, cleanBody);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const getFollowup = async (props, inquiryId) => {
  try {
    let url = `${Url}-followup/list?inquiryId=${inquiryId}`;
    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const updateFollowup = async (props, id, Data) => {
  try {
    let body = {
      type: Data?.type,
      outcome: Data?.outcome,
      notes: Data?.notes,
      nextFollowupDate: Data?.nextFollowupDate,
      updatedBy: props?.authData?.ClidToken,
    };

    const cleanBody = cleanObject(body);

    let response = await apiClient.put(
      `${Url}-followup?id=${id}`,
      cleanBody,
    );

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

export const deleteFollowup = async (props, id) => {
  try {
    let response = await apiClient.delete(`${Url}-followup?id=${id}`);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
